(function() {
  window.simplifyScorm = {};
})();
